import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconTriangleLeft = props => (
  <SvgIcon {...props} viewBox="0 0 5 10">
    <path d="m5 0-5 5 5 5v-10z" />
  </SvgIcon>
);

export default IconTriangleLeft;



// WEBPACK FOOTER //
// ./src/components/icons/IconTriangleLeft.js